define('app/sf/humanise/name/sf-humanise-name-filter',[],function () {
	"use strict";
	return sfHumaniseNameFilter;
	function sfHumaniseNameFilter(palette) {
		return !palette ? "" : palette
			.replace(/-/g, " ")
			.replace(/\b[a-z]/g, function (match) {
				return match.toUpperCase()
			});
	}
});
